import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "business-group",
  "use": "business-group-usage",
  "viewBox": "0 0 30 34",
  "content": "<symbol viewBox=\"0 0 30 34\" xmlns=\"http://www.w3.org/2000/svg\" id=\"business-group\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 0H7V17H0V0ZM8 5H15V17H8V5ZM1 1H3V3H1V1ZM6 1H4V3H6V1ZM1 4H3V6H1V4ZM6 4H4V6H6V4ZM1 7H3V9H1V7ZM6 7H4V9H6V7ZM1 10H3V12H1V10ZM6 10H4V12H6V10ZM9 6H11V8H9V6ZM14 6H12V8H14V6ZM9 9H11V11H9V9ZM14 9H12V11H14V9ZM12 12H14V14H12V12Z\" transform=\"scale(2)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol